export const selectAccountDetails = (state) => state.account.details;
export const selectAccountDetailsLoading = (state) => state.account.loading;
export const selectAccountDetailsError = (state) => state.account.error;
export const selectAccountNetworkSettings = (state) => state.account.accountNetworkSettings;
